import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "tw-text-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_base_alert = _resolveComponent("base-alert");
  var _component_base_button = _resolveComponent("base-button");
  var _component_BaseBtModal = _resolveComponent("BaseBtModal");
  return _openBlock(), _createBlock(_component_BaseBtModal, {
    "show-modal": _ctx.showModal,
    "header-title": _ctx.labels.title,
    "custom-modal-body-classes": "tw-p-20px",
    "custom-modal-header-classes": "lg:tw-pt-30px",
    "custom-modal-dialog-classes": "modal-lg",
    "custom-modal-content-classes": "tw-overflow-hidden",
    onOpened: _ctx.onOpened,
    onClosed: _ctx.onClosed
  }, {
    body: _withCtx(() => [_createVNode(_component_base_alert, {
      "alrt-class": "tw-alert-w-danger tw-text-center tw-my-10px tw-border tw-border-w-danger tw-rounded",
      text: _ctx.labels.reached_limit
    }, null, 8 /* PROPS */, ["text"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_base_button, {
      class: "tw-btn-w-primary btn-md",
      onClick: _withModifiers(_ctx.openSignInModal, ["stop"])
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.labels.sign_in), 1 /* TEXT */)]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["onClick"])])]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["show-modal", "header-title", "onOpened", "onClosed"]);
}